import { connect } from 'react-redux';
import OrgCreationEditor from './OrgCreationEditor';
import { bindActionCreators } from 'redux';
import { fetchOrganization, saveOrganization, clearOrganizationFlags} from 'redux/organizations/OrganizationsActions';

const mapStateToProps = ({ contexts, organizations }) => ({
  selectedOrg: contexts.selectedOrg,
  organization: organizations.organization,
  organizations: organizations.organizations,
  savedOrganizationFlag: organizations.savedOrganizationFlag,
  savedOrganizationFailureFlag: organizations.savedOrganizationFailureFlag,
  savingOrganization: organizations.savingOrganization
});

const mapDispatchToProps = dispatch => ({
  organizationsActions: bindActionCreators({ fetchOrganization, saveOrganization, clearOrganizationFlags }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(OrgCreationEditor);


// WEBPACK FOOTER //
// ./src/components/orgCreation/orgCreationEditor/OrgCreationEditorConnector.js